var map = {
	"./PP_1-30.png": "fd2e",
	"./card.png": "5051",
	"./card1.png": "114a",
	"./casino.png": "a3a7",
	"./category-brand-hover.png": "5a1d",
	"./category-brand.png": "7088",
	"./category-casino-hover.png": "d0f1",
	"./category-casino.png": "8b92",
	"./category-favorite-hover.png": "4a96",
	"./category-favorite.png": "0c37",
	"./category-fishing-game-hover.png": "a202",
	"./category-fishing-game.png": "5406",
	"./category-new-released-hover.png": "9958",
	"./category-new-released.png": "020e",
	"./category-popular-hover.png": "16f5",
	"./category-popular.png": "3513",
	"./category-skill-game-hover.png": "852a",
	"./category-skill-game-hover1.png": "8a2a",
	"./category-skill-game.png": "f15b",
	"./category-skill-game1.png": "7a99",
	"./category-sport-hover.png": "66b3",
	"./category-sport.png": "7873",
	"./ch/category-brand-hover.png": "86f4",
	"./ch/category-brand.png": "2c9c",
	"./ch/category-casino-hover.png": "9afd",
	"./ch/category-casino.png": "22fc",
	"./ch/category-favorite-hover.png": "b0a3",
	"./ch/category-favorite.png": "840c",
	"./ch/category-fishing-game-hover.png": "d5d6",
	"./ch/category-fishing-game.png": "2209",
	"./ch/category-new-released-hover.png": "0784",
	"./ch/category-new-released.png": "9a74",
	"./ch/category-popular-hover.png": "5100",
	"./ch/category-popular.png": "297e",
	"./ch/category-skill-game-hover.png": "2aaf",
	"./ch/category-skill-game.png": "b74d",
	"./ch/category-sport-hover.png": "70ba",
	"./ch/category-sport.png": "5492",
	"./en/category-brand-hover.png": "323d",
	"./en/category-brand.png": "ebef",
	"./en/category-casino-hover.png": "7da6",
	"./en/category-casino.png": "5a15",
	"./en/category-favorite-hover.png": "3ba8",
	"./en/category-favorite.png": "6789",
	"./en/category-fishing-game-hover.png": "5c6b",
	"./en/category-fishing-game.png": "5611",
	"./en/category-new-released-hover.png": "b71f",
	"./en/category-new-released.png": "55d2",
	"./en/category-popular-hover.png": "a30a",
	"./en/category-popular.png": "289e",
	"./en/category-skill-game-hover.png": "b929",
	"./en/category-skill-game.png": "5663",
	"./en/category-sport-hover.png": "7103",
	"./en/category-sport.png": "c725",
	"./favorite.png": "5d68",
	"./fish.png": "895e",
	"./hot.png": "5303",
	"./my/category-brand-hover.png": "90f4",
	"./my/category-brand.png": "7928",
	"./my/category-casino-hover.png": "fb1a",
	"./my/category-casino.png": "3c13",
	"./my/category-favorite-hover.png": "9da6",
	"./my/category-favorite.png": "ab3b",
	"./my/category-fishing-game-hover.png": "5f1f",
	"./my/category-fishing-game.png": "5cf0",
	"./my/category-new-released-hover.png": "c2c9",
	"./my/category-new-released.png": "6463",
	"./my/category-popular-hover.png": "5a33",
	"./my/category-popular.png": "035c",
	"./my/category-skill-game-hover.png": "4e97",
	"./my/category-skill-game.png": "77c0",
	"./my/category-sport-hover.png": "cb93",
	"./my/category-sport.png": "5dee",
	"./new-game.png": "f15c",
	"./slot.png": "9e00",
	"./sport.png": "47c5",
	"./th/category-brand-hover.png": "f160",
	"./th/category-brand.png": "c057",
	"./th/category-casino-hover.png": "27b1",
	"./th/category-casino.png": "7c70",
	"./th/category-favorite-hover.png": "d043",
	"./th/category-favorite.png": "34e1",
	"./th/category-fishing-game-hover.png": "6cd8",
	"./th/category-fishing-game.png": "9e63",
	"./th/category-new-released-hover.png": "d3db",
	"./th/category-new-released.png": "5324",
	"./th/category-popular-hover.png": "c6da",
	"./th/category-popular.png": "5d70",
	"./th/category-skill-game-hover.png": "8de3",
	"./th/category-skill-game-hover1.png": "9197",
	"./th/category-skill-game.png": "fa3c",
	"./th/category-skill-game1.png": "d270",
	"./th/category-sport-hover.png": "a4fe",
	"./th/category-sport.png": "60e2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0f1d";